import { render, staticRenderFns } from "./workspace-member.vue?vue&type=template&id=31f49e87&scoped=true&"
import script from "./workspace-member.vue?vue&type=script&lang=js&"
export * from "./workspace-member.vue?vue&type=script&lang=js&"
import style0 from "./workspace-member.vue?vue&type=style&index=0&id=31f49e87&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f49e87",
  null
  
)

export default component.exports